import "./Ways.css"
import React from "react"
export default function WayTitle(props) {
    return props.ModuleDetails.map((md, index) => {
        return <div
            className="headOfWay"
            key={index}
            style={{
                backgroundColor: props.BackgroundColor,
                color: md
                    ? props.TitleForeColor
                    : ""
            }}
        >
            {md

                ? md.Title
                : ""}
        </div>
    })
}